import axios from "axios";

import { IRecipeTag } from "../../types/api";

export interface IListRecipeTagsParameters {
    token: string;
    type?: number;
}

export interface ICreateRecipeTagParameters {
    token: string;
    name: string;
    slug?: string;
    type?: number;
    position?: number;
}

const authHeaders = (token: string) => ({
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    "Admin-Request": "true",
});

export class RecipeTag {
    static async list(
        parameters: IListRecipeTagsParameters,
    ): Promise<IRecipeTag[]> {
        const { token, ...query } = parameters;
        const { data } = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/api/admins/v1/recipe-tags`,
            {
                headers: authHeaders(token),
                params: query,
            },
        );
        return data;
    }

    static async create(
        parameters: ICreateRecipeTagParameters,
    ): Promise<IRecipeTag> {
        const { token, ...body } = parameters;
        const { data } = await axios.post(
            `${process.env.REACT_APP_API_BASE_URL}/api/admins/v1/recipe-tags`,
            body,
            { headers: authHeaders(token) },
        );
        return data;
    }
}
